import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { makeStyles, Grid, InputAdornment } from '@material-ui/core'
import { Form } from 'react-final-form'
import Button from 'components/Button'
import Accordion from 'components/Accordion'
import { FieldText } from 'components/Fields'
import { validateFormValues } from 'utils/forms'

const useStyles = makeStyles(theme => ({
  normalTop: {
    marginTop: '16px',
  },
  itemTitle: {
    fontFamily: 'Poppins',
    color: '#0F3444',
    fontWeight: '600',
    fontSize: '16px',
  },
  divider: {
    height: 1,
    width: 'calc(100% + 32px)',
    marginLeft: '-16px',
    backgroundColor: theme.palette.grey.main,
  },
  itemsForm: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'space-between',
    rowGap: '20px',
  },
  itemFormField: {
    width: 'calc( 50% - 4px )',
  },
  itemFormFull: {
    width: '100%',
  },
  inputAdornment: {
    marginRight: theme.spacing(2),
  },
}))

export const FieldsForm = ({ classes, disabled }) => {
  const { t } = useTranslation()

  const formFields = [
    {
      name: 'nome',
      label: t('inputs.Ecorregiao'),
      type: 'text',
      classe: classes.itemFormFull,
      required: true,
    },
    {
      name: 'link',
      label: t('inputs.LinkMapa'),
      type: 'text',
      classe: classes.itemFormFull,
      required: false,
    },
    {
      name: 'hectareAreaOriginal',
      label: t('inputs.AreaOriginal'),
      type: 'number',
      classe: classes.itemFormFull,
      required: true,
    },
    {
      name: 'hectareAreaRemanescente',
      label: t('inputs.AreaRemanescente'),
      type: 'number',
      classe: classes.itemFormField,
      required: false,
    },
    {
      name: 'percentualAreaRemanescente',
      label: t('inputs.PorcentagemRemanescente'),
      type: 'number',
      classe: classes.itemFormField,
      required: false,
      suffix: '%',
    },
    {
      name: 'hectareAreaDegradada',
      label: t('inputs.AreaDegradada'),
      type: 'number',
      classe: classes.itemFormField,
      required: false,
    },
    {
      name: 'percentualAreaDegradada',
      label: t('inputs.PorcentagemDegradada'),
      type: 'number',
      classe: classes.itemFormField,
      required: true,
      suffix: '%',
    },
  ]

  return (
    <div className={classes.itemsForm}>
      {formFields.map((field, index) => (
        <FieldText
          key={index}
          required={field.required}
          label={field.label}
          name={field.name}
          className={field.classe}
          type={field.type}
          disabled={disabled}
          {...(field.suffix
            ? {
                InputProps: {
                  endAdornment: (
                    <InputAdornment position='end' className={classes.inputAdornment}>
                      %
                    </InputAdornment>
                  ),
                },
              }
            : {})}
        />
      ))}
    </div>
  )
}

const ItemForm = ({
  item,
  isOpen,
  onExpand,
  onDelete,
  onSubmit,
  isUpdating,
  disabled,
  validation,
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <>
      <Accordion
        hideButton
        variant='no-borders'
        classes={{ title: classes.itemTitle }}
        title={item?.nome}
        onDelete={() => {
          onDelete(item?.id, item?.nome)
          onExpand(null)
        }}
        expanded={isOpen}
        onExpand={onExpand}
        disableDelete={disabled}>
        {isOpen && (
          <Form
            onSubmit={onSubmit}
            validate={validateFormValues(validation)}
            initialValues={{
              nome: item?.nome ?? '',
              hectareAreaOriginal: item?.hectareAreaOriginal ?? '',
              percentualAreaDegradada: item?.percentualAreaDegradada ?? '',
              link: item?.link ?? '',
              hectareAreaRemanescente: item?.hectareAreaRemanescente ?? null,
              hectareAreaDegradada: item?.hectareAreaDegradada ?? null,
              percentualAreaRemanescente: item?.percentualAreaRemanescente ?? null,
              marinho: false,
              terrestre: true,
              id: item?.id ?? '',
            }}
            render={({ handleSubmit, form, pristine, valid }) => (
              <form onSubmit={handleSubmit}>
                <Grid container>
                  <FieldsForm classes={classes} disabled={disabled} />
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction='row'
                      spacing={2}
                      justifyContent='space-between'
                      className={classes.normalTop}>
                      <Grid item>
                        <Button
                          variant='danger'
                          onClick={() => {
                            form.reset()
                            onExpand(null)
                          }}>
                          {t('inputs.cancelar')}
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          type='submit'
                          disabled={Boolean(pristine || !valid) || disabled}
                          loading={isUpdating}>
                          {t('inputs.salvar')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            )}
          />
        )}
      </Accordion>
      <div className={classes.divider} />
    </>
  )
}

ItemForm.propTypes = {
  item: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool,
  disabled: PropTypes.bool,
  validation: PropTypes.object.isRequired,
}

export default ItemForm
